import BaseStepElement from './BaseStepElement.js';
const {LitElement, html, ref, createRef} = window.globalLit;

customElements.define('check-step', class CheckStepElement extends BaseStepElement {

    selectorRef = createRef();

    render() {
        return html`
                <strong>Mark checked</strong> 
                    <element-selector 
                        .value=${this.value.element}
                        ?readonly=${this.readonly}
                        @selectorchange="${this._onChange.bind(this, 'element')}"></element-selector>
        `;
    }
});